export type SchoolAccess = {
  slug: string;
  address?: string;
  phone?: string;
  email?: string;
  hours?: string;
  extra?: { label: string; value: string }[];
  mapQuery?: string;
  mapNote?: string;
};

export const overseasAccess: Record<string, SchoolAccess> = {
  'tiba-netherlands': {
    slug: 'tiba-netherlands',
    address: 'Pater Damiaanstraat 38, 6369 SV Simpelveld, The Netherlands',
    phone: '+31 (0)344 67 39 39',
    email: 'info@butlerschool.com',
    hours: '公式サイトに記載なし（問い合わせには2営業日以内に回答すると記載）',
    mapQuery: 'Pater Damiaanstraat 38, 6369 SV Simpelveld, Netherlands',
  },
  'tiba-china': {
    slug: 'tiba-china',
    address: '中国 四川省 成都',
    phone: '公式サイトに記載なし',
    email: '公式サイトに記載なし',
    hours: '公式サイトに記載なし',
    mapQuery: 'Chengdu, Sichuan, China',
    mapNote: '公式サイトに番地の記載がないため、地図は成都市の広域表示です。',
  },
  'saba-south-africa': {
    slug: 'saba-south-africa',
    address: '南アフリカ ケープタウン（番地の記載なし）',
    phone: '+27 (0)61 631 2878',
    email: 'info@butleracademy.co.za',
    hours: '公式サイトに記載なし',
    mapQuery: 'Cape Town, South Africa',
    mapNote: '公式サイトに番地の記載がないため、地図はケープタウンの広域表示です。',
  },
  'british-butler-academy': {
    slug: 'british-butler-academy',
    address: '7 Bell Yard, Strand, London WC2A 2JR, United Kingdom',
    phone: '+44 20 3290 0142',
    email: 'info@bespokebureau.com',
    hours: '公式サイトに記載なし',
    mapQuery: '7 Bell Yard, Strand, London WC2A 2JR, United Kingdom',
  },
  'magnums-academy': {
    slug: 'magnums-academy',
    address: 'オーストラリア クイーンズランド州（番地の記載なし。研修は世界各地）',
    phone: '+61 419 533 834',
    email: 'josephine@magnumsacademy.com',
    hours: '公式サイトに記載なし',
    mapQuery: 'Queensland, Australia',
    mapNote: '公式サイトに番地の記載がないため、地図はクイーンズランド州の広域表示です。',
  },
  'charles-macpherson-academy': {
    slug: 'charles-macpherson-academy',
    address: '260 Adelaide Street East P.O. Box 82, Toronto, Ontario M5A 1N1, Canada',
    phone: '+1 (416) 369-1146',
    email: 'info@charlesmacpherson.com',
    hours: '公式サイトに記載なし',
    mapQuery: '260 Adelaide Street East, Toronto, Ontario M5A 1N1, Canada',
  },
  'butler-training-institute': {
    slug: 'butler-training-institute',
    address: 'Marinus Naefflaan 11, 7241 GC Lochem, The Netherlands',
    phone: '+31 85 060 3604',
    email: 'info@butlertraininginstitute.com',
    hours: '事前予約制（公式に「Only by appointment.」と記載）',
    extra: [
      { label: '商業会議所番号', value: '80517463' },
      { label: 'VAT番号', value: 'NL861699361B01' },
    ],
    mapQuery: 'Marinus Naefflaan 11, 7241 GC Lochem, Netherlands',
  },
  'butler-academy-paris': {
    slug: 'butler-academy-paris',
    address: '1 Rue Royale, 92210 Saint-Cloud, France（本部）／28 rue de Chambéry, 75015 Paris',
    phone: '+33 1 80 91 61 82',
    email: 'contact@butler-academy.com',
    hours: '公式サイトに記載なし',
    mapQuery: '1 Rue Royale, 92210 Saint-Cloud, France',
    mapNote: '公式サイトには 28 rue de Chambéry, 75015 Paris の記載もあります。地図は本部所在地を表示しています。',
  },
  'the-english-manner': {
    slug: 'the-english-manner',
    address: 'The English Manner, 207 Regent Street, London, W1B 3HH, United Kingdom',
    phone: '+44 (0)20 7856 0590',
    email: 'office@theenglishmanner.com',
    hours: '公式サイトに記載なし',
    extra: [
      { label: '英国法人登記番号', value: '12283223（England & Wales）' },
      { label: '注意', value: '公式サイトに「現在この住所では小包・郵便物を受け取れない」と記載' },
    ],
    mapQuery: '207 Regent Street, London W1B 3HH, United Kingdom',
  },
  'modern-butlers-institute': {
    slug: 'modern-butlers-institute',
    address: '公式サイトに記載なし',
    phone: '公式サイトに記載なし',
    email: '公式サイトに記載なし',
    hours: '公式サイトに記載なし',
    mapNote: '公式サイトに所在地の記載がないため、地図は掲載していません。',
  },
  'british-butler-institute': {
    slug: 'british-butler-institute',
    address: '英国ロンドン（公式ページ本文を取得できず番地は未確認）／ドバイ拠点は客船 Queen Elizabeth 2 のデッキ1',
    phone: '公式サイトに記載なし',
    email: '公式サイトに記載なし',
    hours: '公式サイトに記載なし',
    mapQuery: 'Queen Elizabeth 2, Port Rashid, Dubai, United Arab Emirates',
    mapNote: 'ロンドンの番地は公式ページ本文を取得できず未確認です。地図はドバイ拠点（客船QE2）を表示しています。',
  },
  'dubai-butler-schools': {
    slug: 'dubai-butler-schools',
    address: 'QE2 Hospitality Academy FZE: Port Rashid CT-1 QE2 Ship, Dubai, United Arab Emirates',
    phone: '+971 4 888 1560',
    email: '公式サイトに記載なし',
    hours: '公式サイトに記載なし',
    mapQuery: 'Queen Elizabeth 2, Port Rashid, Dubai, United Arab Emirates',
  },
};

export function accessFor(slug: string): SchoolAccess | undefined {
  return overseasAccess[slug];
}
